import React, { lazy } from 'react';
import {
  ACCOUNT_HOME_URL_PART,
  ACCOUNT_PROFILE_URL_PART,
  ACCOUNT_HOME_VIEW,
  ACCOUNT_PROFILE_VIEW,
  ACCOUNT_INSURANCE_VIEW,
  SETTINGS_VIEW,
  ACCOUNT_FIND_CARE_URL_PART,
  ACCOUNT_FIND_CARE_VIEW,
} from '../../components/Account/util/views';

export default {
  path: '/account',
  children: [
    {
      path: '/login',
      children: [
        {
          path: '/',
          load: () => import(/* webpackChunkName: 'login' */ './../login'),
          exportName: 'symptomsFlowLogin',
        },
        {
          path: '/next/payments',
          children: [
            {
              path: '/:invoiceId',
              load: () => import(/* webpackChunkName: 'login' */ './../login'),
              exportName: 'paymentsFlowLogin',
            },
            {
              path: '/:invoiceId/:locationId',
              load: () => import(/* webpackChunkName: 'login' */ './../login'),
              exportName: 'paymentsFlowLogin',
            },
            {
              path: '/select',
              children: [
                {
                  path: '/group/:groupId',
                  load: () => import(/* webpackChunkName: 'login' */ './../login'),
                  exportName: 'paymentsSelectLogin',
                },
                {
                  path: '/location/:locationId',
                  load: () => import(/* webpackChunkName: 'login' */ './../login'),
                  exportName: 'paymentsSelectLogin',
                },
              ],
            },
          ],
        },
        {
          path: '/next/*',
          load: () => import(/* webpackChunkName: 'login' */ './../login'),
          exportName: 'loginThenRedirect',
        },
        {
          path: '/book-online/:locationId',
          load: () => import(/* webpackChunkName: 'login' */ './../login'),
          exportName: 'bookingWidgetFlowLogin',
        },
        {
          path: '/payments',
          children: [
            {
              path: '/:invoiceId',
              load: () => import(/* webpackChunkName: 'login' */ './../login'),
              exportName: 'paymentsFlowLogin',
            },
            {
              path: '/:invoiceId/:locationId',
              load: () => import(/* webpackChunkName: 'login' */ './../login'),
              exportName: 'paymentsFlowLogin',
            },
            {
              path: '/select',
              children: [
                {
                  path: '/group/:groupId',
                  load: () => import(/* webpackChunkName: 'login' */ './../login'),
                  exportName: 'paymentsSelectLogin',
                },
                {
                  path: '/location/:locationId',
                  load: () => import(/* webpackChunkName: 'login' */ './../login'),
                  exportName: 'paymentsSelectLogin',
                },
              ],
            },
          ],
        },
        {
          path: '/payments/location/:locationId',
          load: () => import(/* webpackChunkName: 'login' */ './../login'),
          exportName: 'paymentsLocationLogin',
        },
        {
          path: '/payments/group/:groupId',
          load: () => import(/* webpackChunkName: 'login' */ './../login'),
          exportName: 'paymentsLocationLogin',
        },
        {
          path: '/b/:bookingId',
          load: () => import(/* webpackChunkName: 'login' */ './../login'),
          exportName: 'generalLoginFlow',
        },
        {
          path: '/account',
          children: [
            {
              path: '/confirm/:bookingId',
              load: () => import(/* webpackChunkName: 'login' */ './../login'),
              exportName: 'waitListFlowLogin',
            },
            {
              path: '/people/:userProfileId',
              load: () => import(/* webpackChunkName: 'login' */ './../login'),
              exportName: 'confirmationLogin',
            },
            {
              path: '/people/:userProfileId/profile',
              load: () => import(/* webpackChunkName: 'login' */ './../login'),
              exportName: 'addPreferredPharmacyLogin',
            },
            {
              path: '/welcome/:userProfileId',
              load: () => import(/* webpackChunkName: 'login' */ './../login'),
              exportName: 'generalLoginFlow',
            },
          ],
        },
      ],
    },
    {
      // TODO-AW: check that this still works
      path: '/book-for-user/:userProfileId',
      load: () => import(/* webpackChunkName: 'cdp2' */ './../cdp/index'),
    },
    {
      path: '/people',
      children: [
        {
          path: '/',
          load: () => import(/* webpackChunkName: 'accountShell' */ './../account/people'),
          exportName: 'accountShell',
          content: lazy(() =>
            import(/*webpackChunkName: 'profile' */ '../../components/Account/PageContents/ProfileList')
          ),
        },
        {
          path: '/:user_profile_id',
          load: () => import(/* webpackChunkName: 'accountShell' */ './../redirectUrls'),
          exportName: 'insuranceRedirectUrl',
        },
        {
          path: '/:user_profile_id/benefits',
          load: () => import(/* webpackChunkName: 'accountShell' */ './../account/people'),
          exportName: 'accountShell',
          content: lazy(() =>
            import(/*webpackChunkName: 'profile' */ '../../components/Account/PageContents/ProfileInsurance')
          ),
          view: ACCOUNT_INSURANCE_VIEW,
        },
        {
          path: `/:user_profile_id/${ACCOUNT_HOME_URL_PART}/:categoryId/:tileId`,
          load: () => import(/*webpackChunkName: 'accountShell' */ './../account/people'),
          exportName: 'accountShell',
          content: lazy(() =>
            import(/*webpackChunkName: 'profile' */ '../../components/Account/PageContents/BigTexForm')
          ),
          view: ACCOUNT_HOME_VIEW,
        },
        {
          path: `/:user_profile_id/${ACCOUNT_HOME_URL_PART}/:secondaryTab`,
          load: () => import(/*webpackChunkName: 'accountShell' */ './../account/people'),
          exportName: 'accountShell',
          content: lazy(() =>
            import(/*webpackChunkName: 'profile' */ '../../components/Account/PageContents/ProfileHome')
          ),
          view: ACCOUNT_HOME_VIEW,
        },
        {
          path: `/:user_profile_id/${ACCOUNT_FIND_CARE_URL_PART}`,
          load: () => import(/* webpackChunkName: 'accountShell' */ './../account/people'),
          exportName: 'accountShell',
          content: lazy(() =>
            import(/*webpackChunkName: 'findCare' */ '../../components/Account/PageContents/ProfileFindCare')
          ),
          view: ACCOUNT_FIND_CARE_VIEW,
          disableGutter: true,
        },
        {
          path: `/:user_profile_id/${ACCOUNT_HOME_URL_PART}`,
          load: () => import(/*webpackChunkName: 'accountShell' */ './../account/people'),
          exportName: 'accountShell',
          content: lazy(() =>
            import(/*webpackChunkName: 'profile' */ '../../components/Account/PageContents/ProfileHome')
          ),
          view: ACCOUNT_HOME_VIEW,
        },
        {
          path: `/:user_profile_id/${ACCOUNT_PROFILE_URL_PART}`,
          load: () => import(/* webpackChunkName: 'accountShell' */ './../account/people'),
          exportName: 'accountShell',
          content: lazy(() =>
            import(/*webpackChunkName: 'profile' */ '../../components/Account/PageContents/Profile')
          ),
          view: ACCOUNT_PROFILE_VIEW,
        },
        {
          path: '/:user_profile_id/visit/:bookingId',
          load: () => import(/* webpackChunkName: 'postVisitSummary' */ './../postVisitSummary'),
          exportName: 'postVisitSummaryRedirectUrl',
        },
      ],
    },
    {
      path: '/settings',
      load: () => import(/* webpackChunkName: 'accountShell' */ './../account/people'),
      exportName: 'accountShell',
      content: lazy(() => import(/*webpackChunkName: 'settings' */ '../account/settings')),
      view: SETTINGS_VIEW,
    },
    {
      path: '/welcome/:userProfileId',
      load: () => import(/* webpackChunkName: 'accountWelcome' */ './../account/welcome'),
      exportName: 'welcomeToSolvFlow',
    },
    {
      path: '/pass/:id',
      load: () => import(/* webpackChunkName: 'pass' */ './../pass'),
      exportName: 'modalPass',
    },
    {
      path: '/waitlist/:bookingId',
      load: () => import(/* webpackChunkName: 'waitList' */ './../waitList'),
      exportName: 'accountWaitList',
    },
    {
      path: '/payments/confirm/:invoiceId',
      load: () => import(/* webpackChunkName: 'payments' */ './../payments'),
      exportName: 'modalConfirmation',
    },
    {
      path: '/payments/:invoiceId',
      load: () => import(/* webpackChunkName: 'payments' */ './../payments'),
      exportName: 'modalPayments',
    },
    {
      path: '/add-review/:bookingId',
      load: () => import(/* webpackChunkName: 'addReview' */ './../addReview'),
      exportName: 'modalReview',
    },
    {
      path: '/t/**',
      load: () => import(/* webpackChunkName: 'tracking' */ './../tracking'),
    },
  ],
};
